module.exports = __webpack_public_path__ + "static/media/bg-blue-image.3bf73f1a.jpg";